import React from 'react'
import Helmet from 'react-helmet'
import { Box, Flex } from 'grid-styled'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { fetchInactiveIdentifier, fetchReplaceIdentifier } from 'alelo-logic/actions'
import ImersiveHeader from '../../elements/ImersiveHeader'
import { setLoading } from '../../modules/PageLoader/actions'
import Button from '../../elements/Button'
import BlockReplaceModal from '../../modules/BlockReplaceModal'
import BlockModal from '../../modules/BlockModal'
import ReceivedModal from '../../modules/ReceivedModal'
import { currencyParser } from 'alelo-logic/utils'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

import imageError from '../../../static/contestacao.png'

import {
  Content,
  Heading,
  Subtitle,
  Paragraph,
  Wrapper,
  ParagraphGray,
  Row,
  CheckBoxCep,
  BoxCep,
  CepText,
  NewAddress,
  WrapperSelectNewAddress,
  WrapperFormNewAddress,
  NewAddressText
} from './styles'

import BlockIdentifiersListOptions from '../../modules/BlockIdentifiersListOptions'
import OtherAddressForm from '../../modules/OtherAddressForm'

import { helmetTitle, title } from './data.json'

const ListOptions = [
  {
    chave: 'RECEBER',
    descricao: 'Receber nova VeloeTag'
  },
  {
    chave: 'POSSUO',
    descricao: 'Já possuo uma VeloeTag, quero apenas substituí-la'
  },
  {
    chave: 'BLOQUEAR',
    descricao: 'Quero apenas bloquear a VeloeTag'
  }
]

class BlockNewIdentifier extends React.Component {
  state = {
    addressSelected: 'actual',
    address: {
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      uf: '',
      cidade: ''
    },
    reasonList: [],
    reasonSelected: '',
    identifier: '',
    idAccount: '',
    optionSelected: null,
    loading: false,
    newIdentifier: '',
    modalBlock: false,
    modalReceive: false,
    modalReplace: false,
    idOrder: ''
  }

  componentDidMount() {
    const reasonList = this.props.reasonListBlock || this.state.reasonList
    const reasonParam = this.getUrlParameter('option')
    const descriptionParam = this.getUrlParameter('description')
    const reasonSelected = descriptionParam
      ? { chave: reasonParam, descricao: descriptionParam }
      : reasonList.filter(el => el.chave === reasonParam)[0]
    const identifier = this.props.match.params.identifierId
    const idAccount = this.props.match.params.id

    if (this.props.user && !this.props.user.enderecos) {
      this.props.history.push(`/minha-veloe/${idAccount}/identificadores`)
      return true
    }

    const {
      cep,
      uf,
      cidade,
      bairro,
      logradouro,
      numero,
      complemento
    } = this.props.user.enderecos[0]

    this.setState({
      reasonList,
      reasonSelected,
      identifier,
      idAccount,
      optionSelected: '',
      address: {
        cep,
        logradouro,
        numero,
        complemento,
        bairro,
        uf,
        cidade
      }
    })
  }

  getUrlParameter = name => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    var results = regex.exec(location.search)
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
  }

  changeCheckBox = evt => {
    this.setState({ addressSelected: evt.target.value })
  }

  handleSave = values => {
    this.setState({ loading: true })
    const { reasonSelected, identifier, idAccount, optionSelected, newIdentifier } = this.state
    const { shoModalErro, fetchInactive, fetchReplace } = this.props

    if (optionSelected === 'BLOQUEAR') {
      const data = {
        codigoIdentificador: identifier,
        codigoConta: idAccount,
        motivoInativacaoIdentificador: reasonSelected.chave,
        motivoInativacaoIdentificadorDescricao: reasonSelected.descricao
      }
      fetchInactive(data)
        .then(response => {
          this.setState({ loading: false, idOrder: response.result, modalBlock: true })
        })
        .catch(error => {
          console.log('error', error)
          error.json().then(reponse => {
            shoModalErro(CONFIRM_UPDATE, {
              modalTitle:
                reponse.message || 'Problemas ao bloquear sua veloeTag tente novamente mais tarde.',
              image: imageError
            })
            this.setState({ loading: false })
          })
        })
    } else if (optionSelected === 'POSSUO') {
      const data = {
        codigoIdentificador: identifier,
        codigoConta: idAccount,
        motivoInativacaoIdentificador: reasonSelected.chave,
        motivoInativacaoIdentificadorDescricao: reasonSelected.descricao,
        novoCodigoIdentificador: newIdentifier
      }
      fetchReplace(data)
        .then(response => {
          console.log(response)
          this.setState({ loading: false, idOrder: response.result, modalReplace: true })
        })
        .catch(error => {
          error.json().then(reponse => {
            shoModalErro(CONFIRM_UPDATE, {
              modalTitle: reponse.message,
              image: imageError
            })
            this.setState({ loading: false })
          })
        })
    } else if (optionSelected === 'RECEBER') {
      const { addressSelected } = this.state
      let addressNew = null

      if (addressSelected === 'new') {
        const { additionalInfo, address, city, neighborhood, number, state, zipCode } = values[0]

        addressNew = {
          cep: zipCode,
          logradouro: address,
          numero: number,
          complemento: additionalInfo || '',
          bairro: neighborhood,
          uf: state,
          cidade: city
        }
      } else {
        const { cep, logradouro, numero, complemento, bairro, uf, cidade } = this.state.address
        addressNew = {
          cep,
          logradouro,
          numero,
          complemento,
          bairro,
          uf,
          cidade
        }
      }
      const data = {
        codigoIdentificador: identifier,
        codigoConta: idAccount,
        motivoInativacaoIdentificador: reasonSelected.chave,
        motivoInativacaoIdentificadorDescricao: reasonSelected.descricao,
        endereco: addressNew
      }
      fetchReplace(data)
        .then(response => {
          this.setState({ loading: false, idOrder: response.result, modalReceive: true })
        })
        .catch(error => {
          console.log('error', error)
          error.json().then(reponse => {
            shoModalErro(CONFIRM_UPDATE, {
              modalTitle:
                reponse.message || 'Problemas ao bloquear sua veloeTag tente novamente mais tarde.',
              image: imageError
            })
            this.setState({ loading: false })
          })
        })
    }
  }

  handleChange = e => {
    this.setState({ optionSelected: e.currentTarget.value })
  }

  handleChangeNewVeloeTag = value => {
    const result = Object.keys(value).map(function(key) {
      return [value[key]]
    })

    const valueFilter = result.splice(0, result.length - 1).join('')
    this.setState({ newIdentifier: valueFilter })
  }

  handleClick = async () => {
    this.setState({ modal: false })
    this.props.history.push(`/minha-veloe/${this.props.match.params.id}/identificadores`)
  }

  render() {
    const { history, handleDelete, saving, match, account = {} } = this.props
    const {
      reasonSelected,
      identifier,
      optionSelected,
      loading,
      newIdentifier,
      addressSelected,
      address,
      modalBlock,
      modalReceive,
      modalReplace,
      idOrder
    } = this.state

    const { wl: isWhiteLabel = false } = account
    const [, ...listReasonsWithoutNewIdentifier] = ListOptions

    return (
      <section>
        <ImersiveHeader text="Minhas Veloetags" back={history.goBack} />
        <Content>
          <Box width={[1, 1]}>
            <Helmet title={helmetTitle} />
            <Heading>{title}</Heading>
            <Row>
              <ParagraphGray>MOTIVO</ParagraphGray>
              <Subtitle>{reasonSelected.descricao}</Subtitle>
            </Row>
            <Row>
              <ParagraphGray>VELOETAG A SER BLOQUEADA/SUBSTITUIDA</ParagraphGray>
              <Subtitle>{identifier}</Subtitle>
            </Row>
            <Row>
              <Box width={[1, 6 / 12]}>
                <Wrapper>
                  <Subtitle>Selecione uma opção</Subtitle>
                  <BlockIdentifiersListOptions
                    list={isWhiteLabel ? listReasonsWithoutNewIdentifier : ListOptions}
                    handleChange={this.handleChange}
                    optionSelected={optionSelected}
                    handleChangeNewVeloeTag={this.handleChangeNewVeloeTag}
                    newIdentifier={newIdentifier}
                  />
                </Wrapper>
              </Box>
            </Row>
            {(optionSelected === 'RECEBER' || optionSelected === 'POSSUO') && (
              <Row>
                <Box width={[1, 6 / 12]}>
                  <Paragraph>
                    {reasonSelected.cobrar && (
                      <p>
                        Para substituir sua VeloeTag, será necessário o pagamento do valor adicional
                        de R${currencyParser(reasonSelected.valor)} que será descontado do seu saldo
                        atual.
                      </p>
                    )}
                  </Paragraph>
                </Box>
              </Row>
            )}
            {optionSelected !== 'RECEBER' && (
              <Row>
                <Flex wrap>
                  <Box width={[1, 'auto']}>
                    <Button buttonType="white" onClick={() => history.goBack()} text="Cancelar" />
                  </Box>
                  <Box width={[1, 'auto']} ml={[0, 30]} mt={[20, 0]}>
                    <Button
                      disabled={!optionSelected || loading}
                      loading={loading}
                      buttonType="skyBlue"
                      text={optionSelected === 'POSSUO' ? 'Substituir' : 'Bloquear'}
                      onClick={() => this.handleSave()}
                    />
                  </Box>
                </Flex>
              </Row>
            )}
            {optionSelected === 'RECEBER' && (
              <Row>
                <Box width={[1]}>
                  <Flex align="center" px={[0, 0, 0, 0]}>
                    <Box width={[1, 1]}>
                      <Row>
                        <Subtitle>Confirme endereço de entrega</Subtitle>
                      </Row>
                      <Row>
                        <BoxCep>
                          <CheckBoxCep
                            type="radio"
                            value="actual"
                            checked={addressSelected === 'actual'}
                            onChange={e => this.changeCheckBox(e)}
                          />
                          <CepText>
                            {address.logradouro}, {address.numero}, {address.complemento}{' '}
                            {address.bairro} - {address.cidade} - {address.uf} -{address.cep}
                          </CepText>
                        </BoxCep>
                      </Row>
                      <Row>
                        <NewAddress focus={addressSelected === 'new'}>
                          <WrapperSelectNewAddress>
                            <NewAddressText>
                              <CheckBoxCep
                                type="radio"
                                value="new"
                                checked={addressSelected === 'new'}
                                onChange={e => this.changeCheckBox(e)}
                              />
                              <CepText>Outro endereço de entrega</CepText>
                            </NewAddressText>
                          </WrapperSelectNewAddress>
                          <WrapperFormNewAddress>
                            {addressSelected === 'new' ? (
                              <OtherAddressForm
                                initialValues={{ address: [] }}
                                onSubmit={values => this.handleSave(values.address)}
                                onDelete={handleDelete}
                                length={address ? address.length : 0}
                                saving={saving}
                                match={match}
                                history={history}
                                loadingButton={loading}
                                disableButton={loading}
                              />
                            ) : null}
                          </WrapperFormNewAddress>
                        </NewAddress>
                      </Row>
                      {optionSelected === 'RECEBER' &&
                        addressSelected === 'actual' && (
                          <Row>
                            <Flex wrap>
                              <Box width={[1, 'auto']}>
                                <Button
                                  buttonType="white"
                                  onClick={() => history.goBack()}
                                  text="Cancelar"
                                />
                              </Box>
                              <Box width={[1, 'auto']} ml={[0, 30]} mt={[20, 0]}>
                                <Button
                                  disabled={!optionSelected || loading}
                                  loading={loading}
                                  width="185px"
                                  buttonType="skyBlue"
                                  text="Enviar Pedido"
                                  onClick={() => this.handleSave()}
                                />
                              </Box>
                            </Flex>
                          </Row>
                        )}
                    </Box>
                  </Flex>
                </Box>
              </Row>
            )}
          </Box>
        </Content>
        {modalBlock && <BlockModal handleClick={this.handleClick} idPedido={idOrder} />}
        {modalReceive && <ReceivedModal handleClick={this.handleClick} idPedido={idOrder} />}
        {modalReplace && <BlockReplaceModal handleClick={this.handleClick} idPedido={idOrder} />}
      </section>
    )
  }
}

export const mapStateToProps = ({ form, reducer }) => ({
  form,
  account: reducer.account,
  user: reducer.user,
  reasonListBlock: reducer.reasonsListBlock.reasons
})

export const mapDispatchToProps = dispatch => ({
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  fetchInactive: data => dispatch(fetchInactiveIdentifier(data)),
  fetchReplace: data => dispatch(fetchReplaceIdentifier(data)),
  shoModalErro: (imagem, infos) => dispatch(showModal(imagem, infos))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BlockNewIdentifier))



// WEBPACK FOOTER //
// ./src/app/pages/BlockIdentifierNew/index.js